import { NavigateBefore as NavigateBeforeIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';
import { useCanPanBack } from '../../../stores/TimeRangeHistoryStore';
import { useTimeRangeNavigation } from '../../../utilities/TimeRangeNavigationUtilities';

export default function PanBackAction(props) {
    const [canPanBack] = useCanPanBack();
    const { enabled, panBack } = useTimeRangeNavigation();

    return enabled ? (
        <Action
            icon={<NavigateBeforeIcon />}
            tooltip={t`Pan the time range backwards`}
            disabled={!canPanBack}
            onClick={panBack}
            {...props}
        />
    ) : null;
}
